import { useAsyncData, useRoute } from '#imports'
import { ref, watch } from 'vue'

import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'
import { reviewsRequestEndpoints } from '~/scopes/reviews/reviews-display/constants'

function useFetchRating() {
  const route = useRoute()
  const { productId } = useUrlParams()
  const $httpFetch = useHttpFetch()

  const uuid: string = route.params?.uuid ? route.params.uuid : productId
  const routeName = route.name?.toString() ?? ''
  const endpoint = reviewsRequestEndpoints?.[routeName]?.getRating

  if (!endpoint) return { data: ref(), error: ref(), pending: ref(false) }

  return useAsyncData(
    getAsyncDataKey('reviews-global-rating', { uuid, routeName }),
    () => {
      return $httpFetch(endpoint, { pathParams: { uuid } })
    },
  )
}

export function useGlobalRating() {
  const route = useRoute()

  const logger = useLogger()

  const { data: ratesResponse, error, pending } = useFetchRating()

  watch(
    error,
    () => {
      if (error.value instanceof Error) {
        logger.error(`[REVIEWS][${route.name?.toString()}]`, {
          error: error.value,
          owners: ['bot-squad-content-front'],
        })
      }
    },
    { immediate: true },
  )

  return {
    pendingRatesResponse: pending,
    ratesResponse,
  }
}
